import { useEffect } from "react";
import { useLocation } from "./router";
import { SiteHeader } from "../components/SiteHeader";
import { SiteFooter } from "../components/SiteFooter";
import { HomePage } from "../pages/HomePage";
import { StylesPage } from "../pages/StylesPage";
import { PlantsPage } from "../pages/PlantsPage";
import { ServicesPage } from "../pages/ServicesPage";
import { GuidePage } from "../pages/GuidePage";
import { DesignerPage } from "../features/designer/DesignerPage";
import { NotFoundPage } from "../pages/NotFoundPage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default function App() {
  const { pathname } = useLocation();
  const page =
    pathname === "/" ? <HomePage /> :
    pathname === "/phong-cach" ? <StylesPage /> :
    pathname === "/thu-vien-cay" ? <PlantsPage /> :
    pathname === "/goi-dich-vu" ? <ServicesPage /> :
    pathname === "/cam-nang" ? <GuidePage /> :
    pathname === "/thiet-ke" ? <DesignerPage /> :
    <NotFoundPage />;

  return (
    <>
      <a className="skip-link" href="#noi-dung">
        Bỏ qua điều hướng
      </a>
      <ScrollManager />
      <SiteHeader />
      <main id="noi-dung">
        {page}
      </main>
      <SiteFooter />
    </>
  );
}
